import React from 'react'
import {
  PageContent,
  ContentMenu,
  ContentMenuTab,
  MapWidget,
  MapMenu,
  MapItem,
  MapTabs,
  MapTab,
  LayerGroup,
  LayerItem,
  Heading,
  Image,
  Text
} from 'components/library'
import { Slider } from 'content/components/slider/Slider'
import { Layer } from 'components/library/widgets/map/components'
import { checkIE11 } from 'helpers'
import mapBaseImage from 'components/library/widgets/map/assets/baseMap-01.svg'
import mapBaseImage01 from './assets/basemap-01.png'
import layer01 from './assets/maplayer_3_1_3_1-01.svg'
import layer02 from './assets/maplayer_3_1_3_2-01.svg'
import layer02IE from './assets/maplayer_3_1_3_2-01-IE.svg'
import layer03 from './assets/maplayer_3_1_3_3-01.svg'
import img01 from './assets/4.2-extra-assistentie.jpg'
import layer0101 from './assets/01-01.svg'
import layer0102 from './assets/02-01.svg'
import layer0103 from './assets/03-01.svg'
import layer0104 from './assets/04-01.svg'
import './Aspect01.css'

class Aspect01 extends React.Component {
  state = {
    currentSliderItem: 0,
  }

  handlecurrentSliderItem = item => {
    this.setState({ currentSliderItem: item })
  }

  render() {
    return (
      <div className="Chapter03-Aspect01">
        <PageContent nospacing>
          <ContentMenu
            menuOnTop
            activeHasBackground
            tabs={[
              'Beperkt Zicht Omstandigheden',
              'Vooralarm & Vliegtuig Ongeval ',
              'Activatie Baan 09-27',
            ]}>

            <ContentMenuTab>
              <MapWidget
                mapImage={mapBaseImage01}
                mapBounds={[[0, 0], [1489, 2068]]}
                options={{ minZoom: -0.7 }}>

                <MapMenu>
                  <MapItem center={[774,1033]} zoom={-0.7}>
                    <MapTabs className={'Tab-01'}>

                      <MapTab active label="BZO-A" showText={
                        <div>
                          <ul>
                            <li>Horizontaal zicht tussen 550 en 1500 meter.</li>
                            <li>Je mag geen gebruik meer maken van de Noordelijke- en Zuidelijke trekkerroute.</li>
                            <li>Je moet anti-collision lights en navigation lights voeren. Als dit niet kan, door een defect aan de stroomvoorziening van het vliegtuig of de lampen zelf, is er begeleiding nodig.</li>
                          </ul>
                        </div>
                      }>
                        <Layer url={layer0101} bounds={[[0, 0], [1489, 2068]]} />
                      </MapTab>

                      <MapTab label="BZO-B" showText={
                        <div>
                          <ul>
                            <li>Horizontaal zicht tussen 350 en 550 meter.</li>
                            <li>PA t/m PD zijn niet beschikbaar voor sleepverkeer.</li>
                            <li>Indien naderende vliegtuigen op baan 18L-36R  een automatische landing inzetten, mag je deze baan niet meer met een A380 kruisen. Het kielvak van de A380 kan het signaal verstoren van de instrumenten die de piloot nodig heeft om te landen.</li>
                          </ul>
                        </div>
                      }>
                        <Layer url={layer0102} bounds={[[0, 0], [1489, 2068]]} />
                      </MapTab>

                      <MapTab label="BZO-C" showText={
                        <div>
                          <ul>
                            <li>Horizontaal zicht tussen 200 en 300 meter.</li>
                            <li>In deze fase komen er, naast de restricies uit BZO-A en BZO-B,  geen extra restricties bij.</li>
                          </ul>
                        </div>
                      }>
                        <Layer url={layer0103} bounds={[[0, 0], [1489, 2068]]} />
                      </MapTab>

                      <MapTab label="BZO-D" showText={
                        <div>
                          <ul>
                            <li>Horizontaal zicht is minder dan 200 meter.  </li>
                            <li>Sleepbewegingen, met of zonder vliegtuig, zijn niet meer toegestaan.</li>
                            <li>Uitzondering hierop is het Kilo-platform, begrensd door de holdingpunten GD en GL. Dit platform is namelijk officieel geen onderdeel van Airside.</li>
                          </ul>
                        </div>
                      }>
                        <Layer url={layer0104} bounds={[[0, 0], [1489, 2068]]} />
                      </MapTab>

                    </MapTabs>
                  </MapItem>
                </MapMenu>
              </MapWidget>
            </ContentMenuTab>

            <ContentMenuTab>
              <div className="has-two-col">
                <div className="col-01">
                  <Heading h2>Als er sprake is van een vooralarm of een vliegtuig ongeval kunnen er restricties opgelegd worden.</Heading>
                  <ul className="List-space">
                    <li>Apron Control kan bij deze alarmvormen restricties opleggen aan het sleepverkeer.</li>
                    <li>LVNL kan restricties opleggen voor het kruisen van start- en landingsbanen.</li>
                    <li>Voor jou als sleeptrekkerchauffeur is het daarom belangrijk dat je het kanaal van Apron Control altijd blijft uitluisteren.</li>
                  </ul>
                </div>
                <div className="col-02">
                  <Image src={img01}/>
                </div>
              </div>
            </ContentMenuTab>

            <ContentMenuTab>
              <div className="Map-base">
                <MapWidget
                  mapImage={mapBaseImage}
                  height={760}
                  mapBounds={[[0, 0], [3556, 3406]]}
                  options={{ minZoom: -1.5 }}>

                  <LayerGroup active={this.state.currentSliderItem}>
                    <LayerItem
                      url={layer01}
                      bounds={[[0, 0], [3556, 3406]]}
                      center={[2675,2058]}
                      zoom={-1.16} />

                    <LayerItem
                      url={checkIE11() ? layer02IE : layer02}
                      bounds={[[0, 0], [3556, 3406]]}
                      center={[2219,2060]}
                      zoom={-1.16} />

                    <LayerItem
                      url={layer03}
                      bounds={[[0, 0], [3556, 3406]]}
                      center={[2701,2001]}
                      zoom={-0.67} />
                  </LayerGroup>
                </MapWidget>
              </div>

              <div className="Map-overlay">
                <div className="Map-overlay-cols">
                  <div>
                    <div className="Map-overlay-message">
                      <Text>Let op! Je mag baan 09-27 onder geen beding meer zonder begeleiding oversteken.</Text>
                    </div>
                  </div>
                  <div>
                    <div className="Map-overlay-slider">
                      <Slider onChange={this.handlecurrentSliderItem}>
                        <div>
                          <Text><strong>Algemeen</strong></Text>
                          <Text>In hoofdstuk 2 heb je geleerd onder welke voorwaarden je gebruik mag maken van de Noordelijke trekkerroute. Het kan echter voorkomen dat baan 09-27 alsnog geactiveerd wordt of een BZO-fase wordt afgekondigd. Indien je je op dat moment al op de Noorderlijke trekkerroute richting Schiphol-Centrum bevindt, zijn er twee opties.</Text>
                        </div>
                        <div>
                          <Text><strong>Optie 1</strong></Text>
                          <Text>Je krijgt de opdracht terug te keren naar Schiphol-Oost en eventueel gebruik te maken van de standaard sleeproute.</Text>
                        </div>
                        <div>
                          <Text><strong>Optie 2</strong></Text>
                          <Text>Je vervolgt de route onder begeleiding. Apron Control geeft aan waar je kunt parkeren, totdat het begeleidingsvoertuig bij je is. Vaak is dit op de parkeerstrook tegenover N3.</Text>
                        </div>
                      </Slider>
                    </div>
                  </div>
                </div>
              </div>
            </ContentMenuTab>

          </ContentMenu>
        </PageContent>
      </div>
    )
  }
}

export default Aspect01



// WEBPACK FOOTER //
// ./src/content/chapters/03/01/Aspect01.js